/**
 * Checks if the code is running in a SSR environment.
 * @returns true if running on the server, false if running in the browser
 */
export function isSSR(): boolean {
	return Boolean(
		// In most places there is no document when running on server-side
		typeof document === 'undefined' ||
		// When SSRing editor with full cycle mode we define the document
		// Check Confluence specific environment variable
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		(typeof process !== 'undefined' && process.env.REACT_SSR),
	);
}
